import { Component } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-view-notes-dialog',
  standalone: true,
  imports: [],
  templateUrl: './view-notes-dialog.component.html',
  styleUrl: './view-notes-dialog.component.scss'
})
export class ViewNotesDialogComponent {
  constructor(public config: DynamicDialogConfig) { }
}
